import { createContext } from "react";
import { searchPageData } from "../Models/SearchModel";

interface SearchContext {
    searchData: searchPageData;
    setSearchData: React.Dispatch<React.SetStateAction<searchPageData>>;
}
export const SearchContext = createContext<SearchContext>({
    searchData: {} as searchPageData, 
    setSearchData: () => {}
});